import React, { useState } from 'react';
import { Card, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import LogsTable from '../../components/LogsTable';
import { API, isAdmin, showError, showSuccess } from '../../helpers';

const Log = () => {
  const { t } = useTranslation();
  const [clearTrigger, setClearTrigger] = useState(0);
  const isAdminUser = isAdmin();

  const handleClearAllLogs = async () => {
    try {
      const targetTimestamp = Math.floor(Date.now() / 1000) + 1;
      const res = await API.delete(`/api/log/?target_timestamp=${targetTimestamp}`);
      const { success, message } = res.data;
      if (success) {
        showSuccess(t('log.messages.clear_success'));
        // 触发子组件刷新
        setClearTrigger((prev) => prev + 1);
      } else {
        showError(message || 'Failed to clear logs');
      }
    } catch (e) {
      showError(e.message || 'Failed to clear logs');
    }
  };

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Card.Header className='header'>{t('log.title')}</Card.Header>
            {isAdminUser && (
              <Button size='small' color='red' onClick={handleClearAllLogs}>
                {t('log.buttons.clear_all')}
              </Button>
            )}
          </div>
          <LogsTable trigger={clearTrigger} />
        </Card.Content>
      </Card>
    </div>
  );
};

export default Log;
